import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=46407e1e&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46407e1e')) {
      api.createRecord('46407e1e', component.options)
    } else {
      api.reload('46407e1e', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=46407e1e&", function () {
      api.rerender('46407e1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2U6Kxhn3ADqJo/JS/videoIframe.vue"
export default component.exports